export default {"src":"/_next/static/media/ico-filter.44d8518a.svg","height":1792,"width":1792,"blurWidth":0,"blurHeight":0};